import CollectionView from 'view/collection'
import MediaItemView from 'component/uploader/view/media_upload_item'

export default CollectionView.extend({
    View: MediaItemView,
})
